'use client';

import { HorizontalLeaguesCard } from '@/components/molecules';
import { LeagueCardSkeleton } from '@/components/molecules/skeletons/LeagueCardSkeleton';
import { FeaturedLeaguesModule } from '@/entities/FeaturedLeaguesData';
import { useFeaturedLeaguesQuery } from '@/hooks/hooks';

interface FeaturedLeaguesProps {
	isHomepage?: boolean;
}

export const FeaturedLeagues = ({ isHomepage }: FeaturedLeaguesProps) => {
	const { data: featuredLeagues, isLoading, refetch } = useFeaturedLeaguesQuery();

	if ((featuredLeagues?.data?.results.modules.length == 0 || featuredLeagues?.statusCode !== 200) && !isLoading) {
		return null;
	}

	return (
		<div className="h-full py-10">
			<div className={`mx-auto flex flex-col justify-center ${isHomepage ? 'max-w-screen-2xl' : ''}`}>
				<>
					<div className="flex items-center justify-between px-4">
						<div className="flex flex-col gap-2">
							<h2 className="text-2xl font-semibold text-black">Featured Leagues</h2>
						</div>
						{/* {featuredLeagues?.data?.results?.modules?.length !== 0 && (
							<div className="cursor-pointer text-base font-semibold leading-6 text-experiment hover:underline">Show all</div>
						)} */}
					</div>

					<div className="mt-6 grid w-full grid-cols-1 gap-6 px-4 md:grid-cols-2 xl:grid-cols-3">
						{isLoading ? (
							<LeagueCardSkeleton />
						) : (
							featuredLeagues?.data?.results.modules.map((league: FeaturedLeaguesModule) => {
								return <HorizontalLeaguesCard key={league.moduleUuid} league={league} refetch={refetch} />;
							})
						)}
					</div>
				</>
			</div>
		</div>
	);
};
